// SPDX-License-Identifier: AGPL-3.0-or-later

/**
 * The map's element on the map page: the skip link at the top of every page moves focus straight
 * to it there. A module of its own so the shell can name it without loading the map.
 */
export const MAP_CANVAS_ID = 'map-canvas';
